import React, { useState } from 'react';
import { DISHES } from './menu';

// a random dish other than `current`
export function pickDish(dishes, current, rng = Math.random) {
  const pool = dishes.filter((d) => d !== current);
  return pool.length ? pool[Math.floor(rng() * pool.length)] : dishes[0] || null;
}

function SnackMenu() {
  const [dish, setDish] = useState(() => pickDish(DISHES, null));

  return (
    <div className="fm-pick">
      <p className="fm-pick-label">tonight's pick</p>
      <h3 className="fm-pick-title"><span className="fm-clamp">{dish}</span></h3>
      <p className="fm-pick-note">One of {DISHES.length} things on the list.</p>
      <div className="fm-pick-actions">
        <button type="button" className="ms-btn fm-pick-main" onClick={() => setDish(pickDish(DISHES, dish))}>🎲 What should I eat?</button>
      </div>
    </div>
  );
}

export default SnackMenu;
